/**
 * Трекінг переглянутих вакансій (юзер 2026-06-11): картки вакансій, які
 * юзер уже відкривав/розгортав, позначаються «Переглянуто» і затемнюються.
 *
 * Зберігаємо в localStorage (того ж webview): ловить і відкриття з бот-
 * сповіщення (deep-link /feed/N), і inline-розгортання у стрічці. Без
 * backend — простіше і без ризику. Кеп розміру щоб не роздувати сховище.
 */
const KEY = "viewed_vacancies_v1";
const MAX = 800;

export function getViewedVacancies(): Set<number> {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : null;
    if (Array.isArray(arr)) {
      return new Set(arr.filter((x): x is number => typeof x === "number"));
    }
  } catch {
    /* ignore */
  }
  return new Set();
}

export function markVacancyViewed(id: number): void {
  try {
    const set = getViewedVacancies();
    if (set.has(id)) return;
    let arr = [...set, id];
    if (arr.length > MAX) arr = arr.slice(arr.length - MAX);
    localStorage.setItem(KEY, JSON.stringify(arr));
  } catch {
    /* ignore */
  }
}
